import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Aereo, Hotel, Servico } from 'src/app/model';
import { ServicoService, Util, LoginService } from 'src/app/services';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-servico-card',
  standalone: false,
  templateUrl: './servico-card.component.html',
  styleUrl: './servico-card.component.scss'
})
export class ServicoCardComponent implements OnInit {
  @Input() servico: Servico;
  @Input() quantidadeItens: { Aereos: Aereo[], aereoConsolidacao: boolean, Hoteis: Hotel[], servico: number } = { Aereos: [], aereoConsolidacao: false, Hoteis: [], servico: 0 };
  @Input() empresaId: number = null;
  @Input() statusOrcamento: number;
  @Input() indice: number;
  @Input() termometroValido: boolean;
  @Input() liberarVouhcer: boolean = false;
  @Input() perfilRoot: boolean = false;
  @Input() cardSimplificado: boolean = false;
  @Input() idadeInvalida: boolean = false;
  @Input() cardItem: any;

  @Output() verificaIdadeValida: EventEmitter<void> = new EventEmitter<void>();
  @Output() carregarObjetoEmitter: EventEmitter<number> = new EventEmitter();
  @Output() imprimirVoucherEmitter: EventEmitter<Servico> = new EventEmitter();
  @Output() atualizarServicoEmitter: EventEmitter<number> = new EventEmitter();

  @ViewChild("modalReserva") modalReserva: ModalComponent;
  @ViewChild("modalCancela") modalCancela: ModalComponent;

  removeUltimoHotel: boolean = false;
  mensagensErroReserva: string = "";
  usuario: any;

  constructor(
    private servicoService: ServicoService,
    private utilService: Util,
    private loginService: LoginService,
  ) { }

  ngOnInit(): void {
    this.usuario = this.loginService.user();
    
    const permi = window.localStorage.getItem("permission");
    if (permi != null) {
      var permissoes = JSON.parse(atob(permi));

      this.removeUltimoHotel =
        permissoes.indexOf("remove_ultimo_hotel") > -1 ||
        permissoes.indexOf("admin") > -1 ||
        permissoes.indexOf("root") > -1;
    }

    if (this.cardSimplificado) {
      if(this.cardItem != null && this.cardItem != undefined){
        this.servico = this.cardItem;
      } else {
        this.carregarServico();
      }
    }
  }

  carregarServico() {
    this.servicoService.buscaServicoPorId(this.servico.Id).subscribe(
      (dados) => {
        this.servico = dados;
      },
      (erro) => {
        this.mensagensErroReserva = this.utilService.errorHandler(erro);
        alert(erro);
      }
    );
  }

  removerServico(servico) {
    if (confirm("Confirmar exclusão do serviço?")) {

      if (this.termometroValido) {
        alert(this.utilService.fazerTraducao("Necessário retornar o valor do termômetro para padrão antes de remover esse item."));
        return;
      }

      if (
        !this.perfilRoot &&
        !this.removeUltimoHotel &&
        this.quantidadeItens.Aereos.length > 0 &&
        !this.quantidadeItens.aereoConsolidacao &&
        this.quantidadeItens.servico === 1 &&
        (this.quantidadeItens.Hoteis.length === 0)
      ) {
        alert("É necessário manter pelo menos um item além do aéreo !");
      } else {
        this.servicoService.removerServico(servico).subscribe(
          (dados) => {
            this.servico = dados;
            alert("Serviço removido com sucesso");
            this.atualizarServicoEmitter.emit(this.servico.Id);
            this.carregarObjetoEmitter.emit(dados.ReservaId);
          },
          (erro) => {
            this.mensagensErroReserva = this.utilService.errorHandler(erro);
            alert(erro);
          }
        );
      }
    }
  }

  validaSePodeReservar() {
    this.verificaIdadeValida.emit();
    if (this.idadeInvalida) {
      this.mensagensErroReserva = this.utilService.fazerTraducao('Verifique a Idade dos passageiros.');
      return;
    } else {
      this.modalReserva.open();
    }
  }
}
